import React, { useState } from "react";
import { Button } from "@mui/material";
import PricingSubscriptionModal from "../Pricing/PricingSubscriptionModal";

export default function UpgradeCta({ detail = {}, destination = "credits", label = "Upgrade" }) {
  const [open, setOpen] = useState(false);
  const required = detail?.required_credits;
  const available = detail?.available_credits;
  const hasAmounts = Number.isFinite(required) && Number.isFinite(available);

  return (
    <>
      <Button
        variant="contained"
        size="small"
        data-testid="trial-upgrade-cta"
        {...(destination === "credits"
          ? { component: "a", href: "/settings/usage" }
          : { type: "button", onClick: () => setOpen(true) })}
      >
        {label}
        {hasAmounts ? ` (${required} required, ${available} available)` : ""}
      </Button>
      {destination === "subscription" ? (
        <PricingSubscriptionModal
          open={open}
          dismissible
          copyMode="trial-conversion"
          onClose={() => setOpen(false)}
        />
      ) : null}
    </>
  );
}
